import React from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import TutorialWalkthroughButton from './TutorialWalkthroughButton';
import { pushPurchaseHistoryHeaderButtonEvent, setMoreThan390RecordsError, } from '../../../../utils/purchase-history/analytics';
import { pushEventInfo } from '../../../../utils/analytics';
var warningMessage = "Warning! Please limit the number of transactions to 390 to export transactions to QuickBooks.\n";
var QuickBooksExportButton = function (props) {
    var isDesktopExport = props.isDesktopExport, setQBRenderFlag = props.setQBRenderFlag, setOpenModal = props.setOpenModal, qbCount = props.qbCount, setAlertState = props.setAlertState;
    // const exportTypeName: string = isDesktopExport ? 'Desktop' : 'Online';
    var startQBExportAnalyticsClick = function () {
        // Analytics
        pushEventInfo({
            category: { primaryCategory: 'button submission' },
            eventInfo: { eventName: 'my account settings' },
            myAccount: { settings: 'purchase history: quickbooks start export' },
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "sui-flex ".concat(isDesktopExport ? 'sui-justify-evenly' : 'sui-justify-center', " sui-mx-5 sui-py-3") },
            isDesktopExport && (React.createElement(TutorialWalkthroughButton, { setQBRenderFlag: setQBRenderFlag })),
            React.createElement(Button, { variant: "secondary", fullWidth: true, onClick: function () {
                    startQBExportAnalyticsClick();
                    if (qbCount && qbCount >= 390) {
                        setMoreThan390RecordsError();
                        setAlertState({
                            status: 'warning',
                            alertMessage: warningMessage,
                            onClose: function () { return setAlertState(null); },
                        });
                        setOpenModal(false);
                    }
                    if (isDesktopExport) {
                        pushPurchaseHistoryHeaderButtonEvent('desktop');
                        setQBRenderFlag('desktop');
                    }
                    if (qbCount && qbCount < 390) {
                        pushPurchaseHistoryHeaderButtonEvent('online');
                        setQBRenderFlag('online');
                    }
                } }, "Start Export"))));
};
export default QuickBooksExportButton;
